import {
  COMPANY_EMAIL,
  COMPANY_LOCATION,
  COMPANY_PHONE_TEXT,
  HEADER_MENUS,
  PA_RESIDENCY_TRAINING_PROGRAM,
  PATIENT_RESOURCES_PAYMENTS,
  SCHEDULE_A_PROCEDURE,
  PHYSICIAN_DIRECTORY,
} from "../utils/constants";

export const QUICK_NAVIGATION = [
  {
    link: "#",
    description: COMPANY_LOCATION,
    disabled: true,
    icon: (
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.38338 16.1772C2.84281 9.59472 2 8.91916 2 6.5C2 3.18628 4.68628 0.5 8 0.5C11.3137 0.5 14 3.18628 14 6.5C14 8.91916 13.1572 9.59472 8.61662 16.1772C8.31866 16.6076 7.68131 16.6076 7.38338 16.1772ZM8 9C9.38072 9 10.5 7.88072 10.5 6.5C10.5 5.11928 9.38072 4 8 4C6.61928 4 5.5 5.11928 5.5 6.5C5.5 7.88072 6.61928 9 8 9Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    link: "#",
    description: COMPANY_PHONE_TEXT[0],
    icon: (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.4917 1.30259L10.6479 0.646341C10.339 0.575247 10.0218 0.736575 9.89599 1.02642L8.58349 4.08892C8.46864 4.35689 8.54521 4.67134 8.77216 4.85454L10.4292 6.21079C9.44482 8.30806 7.72489 10.0526 5.58388 11.0561L4.22763 9.39907C4.04169 9.17212 3.72997 9.09556 3.462 9.2104L0.399504 10.5229C0.106925 10.6514 -0.0544027 10.9686 0.0166911 11.2776L0.672941 14.1213C0.7413 14.4167 1.0038 14.6299 1.31278 14.6299C8.31552 14.6299 14.0003 8.95611 14.0003 1.94243C14.0003 1.63618 13.7897 1.37095 13.4917 1.30259Z"
          fill="#D7D7D9"
        />
      </svg>
    ),
  },
  {
    link: "#",
    description: COMPANY_PHONE_TEXT[1],
    icon: (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.4917 1.30259L10.6479 0.646341C10.339 0.575247 10.0218 0.736575 9.89599 1.02642L8.58349 4.08892C8.46864 4.35689 8.54521 4.67134 8.77216 4.85454L10.4292 6.21079C9.44482 8.30806 7.72489 10.0526 5.58388 11.0561L4.22763 9.39907C4.04169 9.17212 3.72997 9.09556 3.462 9.2104L0.399504 10.5229C0.106925 10.6514 -0.0544027 10.9686 0.0166911 11.2776L0.672941 14.1213C0.7413 14.4167 1.0038 14.6299 1.31278 14.6299C8.31552 14.6299 14.0003 8.95611 14.0003 1.94243C14.0003 1.63618 13.7897 1.37095 13.4917 1.30259Z"
          fill="#D7D7D9"
        />
      </svg>
    ),
  },
  // {
  //   link: "/schedule-a-surgical",
  //   description: SCHEDULE_A_PROCEDURE,
  //   icon: (
  //     <svg
  //       width="14"
  //       height="15"
  //       viewBox="0 0 14 15"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M0.875 13.3174C0.875 14.042 1.46289 14.6299 2.1875 14.6299H11.8125C12.5371 14.6299 13.125 14.042 13.125 13.3174V5.87988H0.875V13.3174ZM2.625 8.06738C2.625 7.82676 2.82187 7.62988 3.0625 7.62988H5.6875C5.92812 7.62988 6.125 7.82676 6.125 8.06738V10.6924C6.125 10.933 5.92812 11.1299 5.6875 11.1299H3.0625C2.82187 11.1299 2.625 10.933 2.625 10.6924V8.06738ZM11.8125 2.37988H10.5V1.06738C10.5 0.826758 10.3031 0.629883 10.0625 0.629883H9.1875C8.94687 0.629883 8.75 0.826758 8.75 1.06738V2.37988H5.25V1.06738C5.25 0.826758 5.05312 0.629883 4.8125 0.629883H3.9375C3.69688 0.629883 3.5 0.826758 3.5 1.06738V2.37988H2.1875C1.46289 2.37988 0.875 2.96777 0.875 3.69238V5.00488H13.125V3.69238C13.125 2.96777 12.5371 2.37988 11.8125 2.37988Z"
  //         fill="#D7D7D9"
  //       />
  //     </svg>
  //   ),
  // },
  {
    link: "/patient-resources/howtopay#payment-guide",
    description: PATIENT_RESOURCES_PAYMENTS,
    icon: (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.8309 1.68555H1.1691C0.522569 1.68555 0 2.20812 0 2.85221V11.4078C0 12.0519 0.522569 12.5744 1.1691 12.5744H12.8309C13.4774 12.5744 14 12.0519 14 11.4078V2.85221C14 2.20812 13.4774 1.68555 12.8309 1.68555ZM1.31493 2.85221H12.6851C12.7653 2.85221 12.8309 2.91784 12.8309 2.99805V4.01888H1.1691V2.99805C1.1691 2.91784 1.23472 2.85221 1.31493 2.85221ZM12.6851 11.4078H1.31493C1.23472 11.4078 1.1691 11.3421 1.1691 11.2619V7.12999H12.8309V11.2619C12.8309 11.3421 12.7653 11.4078 12.6851 11.4078ZM4.66667 8.97721V9.94944C4.66667 10.1099 4.53542 10.2411 4.375 10.2411H2.625C2.46458 10.2411 2.33333 10.1099 2.33333 9.94944V8.97721C2.33333 8.8168 2.46458 8.68555 2.625 8.68555H4.375C4.53542 8.68555 4.66667 8.8168 4.66667 8.97721ZM9.33333 8.97721V9.94944C9.33333 10.1099 9.20208 10.2411 9.04167 10.2411H5.73611C5.57569 10.2411 5.44444 10.1099 5.44444 9.94944V8.97721C5.44444 8.8168 5.57569 8.68555 5.73611 8.68555H9.04167C9.20208 8.68555 9.33333 8.8168 9.33333 8.97721Z"
          fill="#D7D7D9"
        />
      </svg>
    ),
  },
  {
    link: "/physician-directory",
    description: PHYSICIAN_DIRECTORY,
    //disabled: true,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z" fill="#D7D7D9" />
      </svg>
    ),
  },
  {
    link: "/pa-residency-training-program",
    description: PA_RESIDENCY_TRAINING_PROGRAM,
    // disabled: true,
    icon: (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.55004 9.72978C4.49775 9.72978 4.44547 9.73744 4.3956 9.75363C4.1121 9.84572 3.81394 9.90479 3.50004 9.90479C3.18613 9.90479 2.88797 9.84572 2.60425 9.75363C2.55438 9.73744 2.50232 9.72978 2.45004 9.72978C1.09247 9.72978 -0.00718341 10.834 3.53386e-05 12.1933C0.00309784 12.7678 0.475379 13.2298 1.05004 13.2298H5.95004C6.52469 13.2298 6.99697 12.7678 7.00004 12.1933C7.00725 10.834 5.9076 9.72978 4.55004 9.72978ZM3.50004 9.02979C4.65985 9.02979 5.60004 8.0896 5.60004 6.92979C5.60004 5.76997 4.65985 4.82979 3.50004 4.82979C2.34022 4.82979 1.40004 5.76997 1.40004 6.92979C1.40004 8.0896 2.34022 9.02979 3.50004 9.02979ZM12.95 2.02979H4.55004C3.971 2.02979 3.50004 2.5165 3.50004 3.11457V4.12979C4.01235 4.12979 4.4866 4.2781 4.90004 4.51916V3.42979H12.6V9.72978H11.2V8.32978H8.40003V9.72978H6.73229C7.1501 10.0949 7.45679 10.577 7.6005 11.1298H12.95C13.5291 11.1298 14 10.6431 14 10.045V3.11457C14 2.5165 13.5291 2.02979 12.95 2.02979Z"
          fill="#D7D7D9"
        />
      </svg>
    ),
  },
  {
    link: `mailto: ${COMPANY_EMAIL}`,
    description: "Contact Us",
    icon: (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.7348 5.34707C13.8414 5.2623 14 5.3416 14 5.47559V11.0674C14 11.792 13.4121 12.3799 12.6875 12.3799H1.3125C0.587891 12.3799 0 11.792 0 11.0674V5.47832C0 5.3416 0.155859 5.26504 0.265234 5.3498C0.877734 5.82559 1.68984 6.42988 4.47891 8.45605C5.05586 8.87715 6.0293 9.76309 7 9.75762C7.97617 9.76582 8.96875 8.86074 9.52383 8.45605C12.3129 6.42988 13.1223 5.82285 13.7348 5.34707ZM7 8.87988C7.63438 8.89082 8.54766 8.08145 9.00703 7.74785C12.6355 5.11465 12.9117 4.88496 13.7484 4.22871C13.907 4.10566 14 3.91426 14 3.71191V3.19238C14 2.46777 13.4121 1.87988 12.6875 1.87988H1.3125C0.587891 1.87988 0 2.46777 0 3.19238V3.71191C0 3.91426 0.0929687 4.10293 0.251563 4.22871C1.08828 4.88223 1.36445 5.11465 4.99297 7.74785C5.45234 8.08145 6.36562 8.89082 7 8.87988Z"
          fill="#D7D7D9"
        />
      </svg>
    ),
  },
];

export const SITE_LINKS = [
  {
    name: "About Us",
    link: HEADER_MENUS[0]?.slug || "/",
  },
  {
    name: "Services",
    link: HEADER_MENUS[1]?.slug || "/",
  },
  {
    name: "Careers",
    link: HEADER_MENUS[5]?.slug || "/",
  },
  {
    name: "International Physicians",
    link: '/international-physicians',
  },
  {
    name: "Physician Assistants",
    link: HEADER_MENUS[3]?.sub[0]?.slug || "/",
  },
  {
    name: "Surgical Assistants",
    link: HEADER_MENUS[3]?.sub[1]?.slug || "/",
  },

  {
    name: "Travel Surgical Assistants",
    link: HEADER_MENUS[6]?.slug || "/",
  },
  {
    name: "Blogs",
    link: "/blogs",
  },
];

export const OUR_SERVICES_LINKS = [
  {
    name: "Cardio-Thoracic Surgery",
    link: HEADER_MENUS[2]?.sub[0]?.slug || "/",
  },
  {
    name: "Orthopedic Surgery",
    link: HEADER_MENUS[2]?.sub[1]?.slug || "/",
  },
  {
    name: "Robotic Surgery",
    link: HEADER_MENUS[2]?.sub[2]?.slug || "/",
  },
  {
    name: "Neuro-Spinal Surgery",
    link: HEADER_MENUS[2]?.sub[3]?.slug || "/",
  },
  {
    name: "General Surgery",
    link: HEADER_MENUS[2]?.sub[4]?.slug || "/",
  },
  {
    name: "OB/GYN Surgery",
    link: HEADER_MENUS[2]?.sub[5]?.slug || "/",
  },
  {
    name: "Schedule A Procedure",
    link: "/schedule-a-surgical",
  },
];

// export const FOOTER_BOTTOM_LINKS = [
//   { href: "/", text: "Current Job Openings" },
//   { href: "/", text: "News and Updates" },
//   { href: "/", text: "Privacy Policy" },
// ];
